// ABOUTME: Maintenance mode wrapper component
// ABOUTME: Shows maintenance page when API is unhealthy, periodically checks status

import { useState, useEffect, useRef, useCallback } from "react";

import { useMaintenanceHealth } from "../model/use-maintenance-health";
import { MaintenancePage } from "../ui/maintenance-page";

const HEALTH_CHECK_INTERVAL_MS = 30_000;
const UNHEALTHY_CHECK_INTERVAL_MS = 5_000;

export function MaintenanceCheck({ children }: { children: React.ReactNode }) {
  const [isHealthy, setIsHealthy] = useState<boolean | null>(null);
  const [isInitialCheck, setIsInitialCheck] = useState(true);
  const { checkHealth } = useMaintenanceHealth();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const runCheck = useCallback(async () => {
    const healthy = await checkHealth();
    if (healthy !== undefined) {
      setIsHealthy(healthy);
      setIsInitialCheck(false);
    }
  }, [checkHealth]);

  useEffect(() => {
    runCheck();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [runCheck]);

  useEffect(() => {
    if (isHealthy === null) return;

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const interval = isHealthy
      ? HEALTH_CHECK_INTERVAL_MS
      : UNHEALTHY_CHECK_INTERVAL_MS;
    intervalRef.current = setInterval(runCheck, interval);
  }, [isHealthy, runCheck]);

  if (isInitialCheck) {
    return null;
  }

  if (isHealthy === false) {
    return <MaintenancePage />;
  }

  return children;
}
